/*jslint browser */
/*global process */

var $ = jQuery;

/**
 *
 */
export default class StorageProduct
{
    private _id: number;
    private _name: string;
    private _variation: number;
    private _price: number;
    private _accessories: Array<StorageProduct>;
    private _items: Array<StorageProduct>;
    private _imageUrl: string;
    private _uniqueKey: string;
    private _setPrice: number;
    private _quantity: number;
    private _url: string;
    private _label: string;

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get variation(): number {
        return this._variation;
    }

    set variation(value: number) {
        this._variation = value;
    }

    get price(): number {
        return this._price;
    }

    set price(value: number) {
        this._price = value;
    }

    get accessories(): Array<StorageProduct> {
        return this._accessories;
    }

    set accessories(value: Array<StorageProduct>) {
        this._accessories = value;
    }

    get items(): Array<StorageProduct> {
        return this._items;
    }

    set items(value: Array<StorageProduct>) {
        this._items = value;
    }

    get imageUrl(): string {
        return this._imageUrl;
    }

    set imageUrl(value: string) {
        this._imageUrl = value;
    }

    get uniqueKey(): string {
        return this._uniqueKey;
    }

    set uniqueKey(value: string) {
        this._uniqueKey = value;
    }

    get setPrice(): number {
        return this._setPrice;
    }

    set setPrice(value: number) {
        this._setPrice = value;
    }

    get quantity(): number {
        return this._quantity;
    }

    set quantity(value: number) {
        this._quantity = value;
    }

    get url(): string {
        return this._url;
    }

    set url(value: string) {
        this._url = value;
    }

    get label(): string {
        return this._label;
    }

    set label(value: string) {
        this._label = value;
    }
}